import React from 'react';
import { cn } from '@/lib/utils';
import { Spinner } from '../shadcn';

export interface LoadingOverlayProps {
    /** Visible to assistive technologies (defaults to “Loading”). */
    label?: string;
    className?: string;
    spinnerClassName?: string;
}

function LoadingOverlay({ label = 'Loading', className, spinnerClassName }: LoadingOverlayProps) {
    return (
        <div
            data-cy="LoadingOverlay"
            role="status"
            aria-busy="true"
            aria-label={label}
            className={cn(
                'bg-background supports-backdrop-filter:bg-background/70 fixed inset-0 z-50 flex items-center justify-center',
                className,
            )}
        >
            <Spinner className={cn('text-primary size-10', spinnerClassName)} aria-hidden />
        </div>
    );
}

export { LoadingOverlay };
